import * as css from 'css/exports.module.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getDirectParent } from '@lib/popups';
import { TagDescriptionInput } from './TagDescriptionInput';
import { TagNameInput } from './TagNameInput';
import { TagOwnersInput } from './TagOwnersInput';
import { useAction } from '@hooks';
import { When } from 'react-if';
import { Button, Col, Divider, Form, Row } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback, useMemo, useState } from 'react';
export const EditTag = ({ tag }) => {
    const [hexColor, setHexColor] = useState(tag.hexColor);
    const requestDelete = useAction(coreActions.requestDeleteCoreTagsById);
    const requestPut = useAction(coreActions.requestPutCoreTagsById);
    const initialFormValues = useMemo(() => {
        const { description, ownerIds, name } = tag;
        return {
            description: description !== null && description !== void 0 ? description : '',
            hexColor,
            name,
            ownerIds: ownerIds.map((id) => String(id))
        };
    }, [hexColor, tag]);
    const handleDelete = useCallback(() => {
        requestDelete({
            id: tag.id
        });
    }, [tag.id, requestDelete]);
    const handleSubmit = useCallback((values) => {
        requestPut(Object.assign(Object.assign({}, values), { hexColor, id: tag.id, ownerIds: values.ownerIds.map((id) => Number(id)) }));
    }, [hexColor, tag.id, requestPut]);
    return (React.createElement("div", { className: 'tag', key: tag.id },
        React.createElement(Form, { className: 'edit', initialValues: initialFormValues, name: String(tag.id), onFinish: handleSubmit },
            React.createElement(Row, { gutter: [Number(css.size16), 0] },
                React.createElement(Col, { span: 6 },
                    React.createElement(TagNameInput, { disabled: tag.autoTagged, getPopupContainer: getDirectParent, hexColor: hexColor, name: 'name', onColorClick: setHexColor })),
                React.createElement(Col, { span: 18 },
                    React.createElement(TagOwnersInput, { disabled: tag.autoTagged, name: 'ownerIds' }))),
            React.createElement(TagDescriptionInput, { disabled: tag.autoTagged, name: 'description' }),
            React.createElement(When, { condition: !tag.autoTagged },
                React.createElement(Row, { justify: 'space-between' },
                    React.createElement(Button, { className: 'tag-save-button', htmlType: 'submit', type: 'primary' }, COPY_SPECIFIC.SAVE),
                    React.createElement(Button, { className: 'tag-delete-button', danger: true, onClick: handleDelete }, COPY_SPECIFIC.DELETE)))),
        React.createElement(Divider, null)));
};
